<template>
    <a :href="link" title="Facebook" aria-labelledby="facebook-icon-link">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4525_1551)">
                <path
                    d="M18.2091 7.99268H14.1975V6.18253C14.1843 6.05035 14.1989 5.91684 14.2403 5.79068C14.2817 5.66453 14.349 5.54853 14.4378 5.45023C14.5266 5.35193 14.6349 5.27352 14.7558 5.22008C14.8766 5.16664 15.0073 5.13936 15.1393 5.14003H17.9643V1.34912H13.8869C10.186 1.34912 9.48913 4.19231 9.48913 5.95507V7.99268H6.66406V11.7836H9.48913V22.6825H14.1975V11.7836H17.8231L18.2091 7.99268Z"
                    stroke="#035266"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    fill="transparent"
                />
            </g>
        </svg>

        <span id="facebook-icon-link" hidden>Facebook</span>
    </a>
</template>

<script setup lang="ts">
    defineProps<{
        link: string;
    }>();
</script>
